export const assignedUsersListConfig = {
  grid: "20px 200px 120px 1fr",
};

export const stagesSchemasListConfig = {
  grid: "130px 1fr 1fr 70px 26px",
};
